<template>
  <div class="processPage">
    <!-- <div class="leftContent">
      <p class="title">
        <span>生产线</span>
      </p>
      <el-tree
        ref="tree"
        :data="productionLineData"
        :props="defaultProps"
        @node-click="handleNodeClick"
        highlight-current
        node-key="id"
        :expand-on-click-node="true"
      >
      </el-tree>
    </div> -->
    <div class="rightContent">
      <el-table stripe border style="width: 100%" height="100%" size="mini" row-key="id"
        :data="productSopData" :cell-style="colStyle">
        <el-table-column type="index" align="center" class-name="drag_move"></el-table-column>
        <el-table-column prop="title" label="自定义工序名称" align="center" min-width="110">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="'ID: '+scope.row.workStation.id" placement="top" :open-delay="300">        
              <span v-if="scope.row.title" class="textOverflow allowSkip" @click="workStationClick(scope.row.workStationOptions)">{{ scope.row.title }}</span>
              <span v-else>{{ scope.row.workStation.name }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="workStation" label="工序" align="center" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.workStation.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="生产线" align="center" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.type">{{ scope.row.type.name }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="workStation" label="重复执行" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="textSuccess" v-if="scope.row.sameRedo">允许</span>
            <span class="textWarning" v-else>不允许</span>
          </template>
        </el-table-column>
        <el-table-column prop="alwaysRedo" label="跳回执行" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="textSuccess" v-if="scope.row.alwaysRedo">允许</span>
            <span class="textWarning" v-else>不允许</span>
          </template>
        </el-table-column>
        <el-table-column prop="ims" label="IMS工序" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="textSuccess" v-if="scope.row.ims">是</span>
            <span class="textWarning" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="uploadLog" label="上传日志" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="textSuccess" v-if="scope.row.uploadLog">是</span>
            <span class="textWarning" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="bestOf" label="局胜制" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.bestOf">{{ scope.row.bestOf.title }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="show" label="客户端显示" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.show == null">-</span>
            <span class="textSuccess" v-else-if="scope.row.show">是</span>
            <span class="textWarning" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="labelType"
          label="标签模板"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.labelType">
              <span v-if="scope.row.labels > 0"
                >有 {{ scope.row.labels }} 个模板</span
              >
              <span class="danger" v-else>模板缺失</span>
            </span>
            <span v-else>不打印标签</span>
          </template>
        </el-table-column>
        <el-table-column
          class-name="operation"
          label="操作"
          align="center"
          width="115px"
        >
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.type && scope.row.type.id!='114'" class="item" effect="dark" content="回退至上一工序(不含失败的产品)" placement="top" :open-delay="300">
              <i @click="rollbackSop($event, scope.row)" class="iconfont icon-huitui"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
              <i @click="editSop($event, scope.row)" class="el-icon-edit"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top" :open-delay="300">
              <i @click="deleteSop($event, scope.row)" class="el-icon-delete"></i>
            </el-tooltip>
            <el-tooltip v-if="!currentProcessKey" class="item" effect="dark" content="上移" placement="top" :open-delay="300">
              <i @click="moveUpSop($event, scope.row)" class="el-icon-arrow-up"></i>
            </el-tooltip>
            <el-tooltip v-if="!currentProcessKey" class="item" effect="dark" content="下移" placement="top" :open-delay="300">
              <i @click="moveDownSop($event, scope.row)" class="el-icon-arrow-down"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <myDialog
      ref="sopDialog"
      :title="sopDialogTitle"
      @rollBack="rollBack"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="sopDialogForm"
          :model="sopDialogForm"
          :rules="sopDialogRules"
          :label-width="labelWidth"
        >
          <div v-if="sopDialogTitle == '复制工序'">
            <el-form-item label="组装工单" size="small">
              <el-select
                v-model="sopDialogForm.productionOrderId"
                placeholder="选择组装工单"
                filterable
                clearable
                class="hiddenSelectDropdown"
                :popper-append-to-body="false"
                @visible-change="
                  selectVisible(
                    $event,
                    'productionOrder',
                    '组装工单',
                    'sopDialogForm'
                  )
                "
              >
                <el-option
                  v-for="(item, index) in pullDownData.productionOrderList"
                  :key="index"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item
              label="上一工序："
              size="small"
              prop="previousId"
              v-if="sopDialogTitle == '添加工序'"
            >
              <el-select
                v-model="sopDialogForm.previousId"
                placeholder="选择产品类别"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in pullDownData.productSopList"
                  :key="index"
                  :label="item.workStation.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工序：" size="small" prop="workStationId">
              <el-cascader
                :options="$parent.pullDownData.workStationList"
                :props="cascaderOption"
                :show-all-levels="false"
                v-model="sopDialogForm.workStationId"
                ref="workStationCascader"
                @change="cascaderChange($event, 'workStationCascader')"
                placeholder="选择工序"
                popper-class="workStationCascader"
                :disabled="sopDialogTitle == '修改工序'"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item v-if="sopDialogTitle == '修改工序'" label="自定义名称：" size="small" prop="title">
              <el-input
                v-model="sopDialogForm.title"
                placeholder="自定义工序名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="标签类型：" size="small">
              <el-select
                v-model="sopDialogForm.labelType"
                placeholder="选择产品类别"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in pullDownData.labelTypeList"
                  :key="index"
                  :label="item.title"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="局胜制：" size="small">
              <el-select
                v-model="sopDialogForm.bestOf"
                placeholder="选择局胜制"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in pullDownData.smtBestOfList"
                  :key="index"
                  :label="item.title"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="myCheckBox">
              <el-checkbox v-model="sopDialogForm.sameRedo">相同工序重复执行</el-checkbox>
              <el-checkbox v-model="sopDialogForm.alwaysRedo">线体内跳回执行</el-checkbox>
              <el-checkbox v-model="sopDialogForm.show">在客户端列表显示</el-checkbox>
              <el-checkbox v-model="sopDialogForm.beforeRedo">不能跳到之前执行</el-checkbox>
              <el-checkbox v-model="sopDialogForm.ims" style="width: 136px;">IMS工序</el-checkbox>
              <el-checkbox v-model="sopDialogForm.uploadLog">上传日志</el-checkbox>
            </div>
            <el-form-item label="工序参数：" size="small" prop="options">
              <el-input
                v-model="sopDialogForm.options"
                type="textarea"
                :autosize="{ minRows: 10, maxRows: 14 }"
                placeholder="参数配置"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    >
    </orderTableSelect>
  </div>
</template>

<script>
import {
  apiProductionLine,
  apiProductSopSearch,
  apiProductSopAdd,
  apiProductSopUpdate,
  apiProductSopDisable,
  apiProductSopEnable,
  apiProductSopDelete,
  apiProductionOrderSopRollback,
  apiProductSopMoveDown,
  apiProductSopMoveUp,
  apiProductSopList,
  apiProductSopCopy,
  apiRestoreSop,
  apiLabelType, apiBestOf, apiProductSopDragSort,
} from "@/api/productionOrder.js";
import myDialog from "@/components/myDialog.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
import Sortable from "sortablejs";

export default {
  components: {
    myDialog,
    orderTableSelect,
  },
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  data() {
    return {
      // tree配置
      defaultProps: {
        children: "children",
        label: "name",
      },
      // 联级配置
      cascaderOption: {
        checkStrictly: true,
        emitPath: false,
        label: "name",
        value: "id",
      },
      pullDownData: {
        productionOrderList: [],
        productSopList: [],
        labelTypeList: [],
        smtBestOfList: [],
      },
      currentProcessKey: undefined,
      productionLineData: [],
      productSopData: [],
      sopDialogTitle: "",
      sopDialogForm: {
        title: null,
        sameRedo: false,
        alwaysRedo: false,
        ims: false,
        uploadLog: false,
        show: true,
        beforeRedo: false,
        bestOf: null,
      },
      sopDialogRules: {
        workStationId: [
          { required: true, message: "工序不能为空！", trigger: "blur" },
        ],
        options: [{ required: true, message: "参数不能为空！", trigger: "blur" }],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  mounted () {
    this.rowDrop();
  },
  methods: {
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody');
      const _this = this;
      let tempName = '';
      let tempId = '';
      Sortable.create(tbody, {
        //  指定父元素下可被拖拽的子元素
        draggable: ".el-table__row",
        animation:500,
        handle: ".drag_move",
        onStart(evt) {
          const index=evt.oldIndex;
          const oldIndexRow  = _this.productSopData.slice(index,index+1)[0];
          tempName = oldIndexRow.workStation.name;
          tempId = oldIndexRow.id;
        },
        onEnd ({ newIndex, oldIndex }) {
          if(newIndex == oldIndex){
            return;
          }
          let newIndexTemp = newIndex + 1;
          let oldIndexTemp = oldIndex + 1;
          _this.$confirm('确定将【'+ tempName +'】从第【'+oldIndexTemp+'】行排序到第【'+newIndexTemp+'】行', "排序工具", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            const res = await apiProductSopDragSort({
              id: tempId,
              sortNum: newIndex
            });
            console.log(res)
            if (res.code == 0) {
              _this.getProductSopSearch("noRemove", _this.getProductSopList);
              _this.$message({
                message: "排序成功",
                type: "success",
              });
            }else {
              _this.getProductSopSearch("noRemove", _this.getProductSopList);
            }
          }).catch(()=>{
            _this.getProductSopSearch("noRemove", _this.getProductSopList);
          });
          const currRow = _this.productSopData.splice(oldIndex, 1)[0];
          _this.productSopData.splice(newIndex, 0, currRow);
          // _this.sortableResult = JSON.stringify(_this.tableData);
        }
      })

    },
    // 生产线
    async getProductionLineData() {
      const res = await apiProductionLine();
      if (res.code == 0) {
        this.productionLineData = JSON.parse(JSON.stringify(res.data));
        this.productionLineData.unshift({
          id: "",
          name: "全部",
        });
        this.$nextTick(() => {
          // this.$refs.tree.setCurrentKey(this.currentProcessKey);
        });
        this.getProductSopList();
        this.getLabelType();
        this.getBestOf();
      }
    },
    // 订单表格提交
    orderTableSubmit({ orderName, labelName, selectRow, origin }) {
      if (labelName == "组装工单多选") {
        this.$set(
          this.dialogForm,
          `${orderName + "Ids"}`,
          selectRow.map((item) => item.id)
        );
        this.$set(this.pullDownData, `addProductionOrderList`, selectRow);
      } else {
        this.$set(this[origin], `${orderName + "Id"}`, selectRow.id);
        this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
      }
    },
    // tree点击
    handleNodeClick(data) {
      if (this.currentProcessKey == data.id) return;
      this.currentProcessKey = data.id;
      this.$parent.currentProcessKey = data.id;
      this.getProductSopSearch();
    },
    // 表格数据
    async getProductSopSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.productSopData = [];
      }
      const res = await apiProductSopSearch({
        orderId: this.tabPaneValue,
        typeId: this.currentProcessKey,
      });
      // console.log(res)
      if (res.code == 0) {
        this.productSopData = res.data;
        this.$parent.productSopData = res.data;
        if (callback) callback();
      }
    },
    // 查询条件-组装工单
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        // if (labelName == "组装工单多选") {
        //   this.$refs.orderTableSelect.parameter = {
        //     customerId: this.dialogForm.customerId,
        //     // 已选择的工单
        //     selectedRow: this.pullDownData.addProductionOrderList.filter(
        //       (item) => this.dialogForm.productionOrderIds.includes(item.id)
        //     ),
        //   };
        // } else {
        //   this.$refs.orderTableSelect.parameter = {
        //     customerId: this.searchConditionForm.customerId,
        //     // customerOrderId: this.searchConditionForm.customerOrderId,
        //   };
        // }
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 新增
    copySopBtn() {
      this.sopDialogTitle = "复制工序";
      this.$refs.sopDialog.dialogVisible = true;
    },
    // 新增
    addNewBtn() {
      this.sopDialogTitle = "添加工序";
      this.$refs.sopDialog.dialogVisible = true;
      this.$set(this.sopDialogForm, "workStationId", "");
      this.$set(this.sopDialogForm, "options", "[]");
      this.$set(this.sopDialogForm, "title", null);
      this.$set(this.sopDialogForm, "bestOf", null);
    },
    // 编辑
    editSop(e, row) {
      this.sopDialogTitle = "修改工序";
      this.$refs.sopDialog.dialogVisible = true;
      this.sopDialogForm = {
        id: row.id,
        workStationId: row.workStation.id,
        title: row.title,
        labelType: row.labelType,
        alwaysRedo: row.alwaysRedo,
        ims: row.ims,
        uploadLog: row.uploadLog,
        sameRedo: row.sameRedo,
        beforeRedo:row.beforeRedo,
        bestOf: row.bestOf ? row.bestOf.code : null,
        options: JSON.stringify(row.workStationOptions, null, "\t"),
        show: row.show,
      };
    },
    rollBack() {
      const h = this.$createElement;
      this.$msgbox({
        title: `提示`,
        message: h("div", null, [
          h("span", null, `请输入工单号:【`),
          h(
            "i",
            { style: "color: var(--themeColor)" },
            this.$parent.tabPaneData.orderNumber
          ),
          h("span", null, `】以确认还原默认配置！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue === this.$parent.tabPaneData.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `工单号输入错误，无法继续！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        let res = {};
        res = await apiRestoreSop({
            id: this.sopDialogForm.id
          });
        if (res.code == 0) {
          this.$refs.sopDialog.dialogVisible = false;
          this.getProductSopSearch("", this.getProductSopList);
          this.$message({
            message: "SOP配置还原成功！",
            type: "success",
          });
        }
      });
    },
    // 对话框提交
    submitData(title) {
      this.$refs.sopDialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title == "复制工序") {
            if (!this.sopDialogForm.productionOrderId) {
              this.$message({
                message: "组装工单不能为空！",
                type: "error",
              });
              return;
            }
            res = await apiProductSopCopy({
              toOrderId: this.tabPaneValue,
              formOrderId: this.sopDialogForm.productionOrderId,
            });
            if (res.code == 0) {
              this.$refs.sopDialog.dialogVisible = false;
              this.getProductSopSearch("", this.getProductSopList);
              this.$message({
                message: "复制成功",
                type: "success",
              });
            }
          } else {
            try {
              JSON.parse(this.sopDialogForm.options);
            } catch {
              this.$message({
                message: "工序参数格式错误",
                type: "error",
              });
            }
            if (title == "添加工序") {
              res = await apiProductSopAdd({
                ...this.sopDialogForm,
                options: JSON.parse(this.sopDialogForm.options),
                orderId: this.tabPaneValue,
              });
              if (res.code == 0) {
                this.$refs.sopDialog.dialogVisible = false;
                this.getProductSopSearch("", this.getProductSopList);
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
              }
            } else if (title == "修改工序") {
              res = await apiProductSopUpdate({
                ...this.sopDialogForm,
                options: JSON.parse(this.sopDialogForm.options),
                orderId: this.tabPaneValue,
              });
              if (res.code == 0) {
                this.$refs.sopDialog.dialogVisible = false;
                this.getProductSopSearch("noRemove", this.getProductSopList);
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              }
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.sopDialogForm.resetFields();
      this.sopDialogForm = {
        sameRedo: false,
        alwaysRedo: false,
        ims: false,
        uploadLog: false,
        beforeRedo:false,
        show: true,
        bestOf: null,
      };
      this.$refs.workStationCascader.$refs.panel.activePath = [];
    },
    // 表格工序点击
    workStationClick(option) {
      this.$workStationDetail(option);
    },
    // 禁用
    disableSop(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.workStation.name }, "禁用", "工序").then(
        async () => {
          const res = await apiProductSopDisable({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getProductSopSearch("noRemove", this.getProductSopList);
            this.$message({
              message: "禁用成功",
              type: "success",
            });
          }
        }
      );
    },
    // 启用
    enableSop(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.workStation.name }, "启用", "工序").then(
        async () => {
          const res = await apiProductSopEnable({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getProductSopSearch("noRemove", this.getProductSopList);
            this.$message({
              message: "启用成功",
              type: "success",
            });
          }
        }
      );
    },
    rollbackSop(e,row) {
      e.target.blur();
      this.$allOperation({ name: row.title }, "回退", "工序").then(
        async () => {
          const res = await apiProductionOrderSopRollback({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getProductSopSearch("noRemove", this.getProductSopList);
            this.$message({
              message: "回退成功",
              type: "success",
            });
          }
        }
      );
    },
    // 删除
    deleteSop(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.title }, "删除", "工序名称").then(
        async () => {
          const res = await apiProductSopDelete({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getProductSopSearch("noRemove", this.getProductSopList);
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        }
      );
    },
    // 上移
    moveUpSop(e, row) {
      e.target.blur();
      this.$confirm(`是否上移【${row.workStation.name}】？`, "上移工序", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiProductSopMoveUp({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getProductSopSearch("noRemove", this.getProductSopList);
          this.$message({
            message: "上移成功",
            type: "success",
          });
        }
      });
    },
    // 下移
    moveDownSop(e, row) {
      e.target.blur();
      this.$confirm(`是否下移【${row.workStation.name}】？`, "下移工序", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiProductSopMoveDown({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getProductSopSearch("noRemove", this.getProductSopList);
          this.$message({
            message: "下移成功",
            type: "success",
          });
        }
      });
    },
    // 联级选择器改变时触发
    cascaderChange(val, ref) {
      if (val) {
        let workStationList = this.$parent.pullDownData.workStationList;
        let checkData = {};
        this.$refs[ref].toggleDropDownVisible();
        workStationList.forEach((item) => {
          if (item.children) {
            item.children.forEach((child) => {
              // console.log(val == child.id)
              val == child.id ? (checkData = child) : "";
            });
          }
        });
        this.$set(this.sopDialogForm, "sameRedo", checkData.sameRedo);
        this.$set(this.sopDialogForm, "alwaysRedo", checkData.alwaysRedo);
        this.$set(this.sopDialogForm, "ims", checkData.ims);        
        this.$set(this.sopDialogForm, "uploadLog", checkData.uploadLog);
        this.$set(
          this.sopDialogForm,
          "options",
          checkData.workStationOptions
            ? JSON.stringify(checkData.workStationOptions, null, "\t")
            : "[]"
        );
      }
    },
    // 生产工序-上一工序下拉
    async getProductSopList() {
      const res = await apiProductSopList({
        orderId: this.tabPaneValue,
        // typeId: this.currentProcessKey,
      });
      if (res.code == 0) {
        this.pullDownData.productSopList = res.data;
      }
    },
    // 标签类别
    async getLabelType() {
      const res = await apiLabelType();
      if (res.code == 0) {
        this.pullDownData.labelTypeList = res.data;
      }
    },
    // 局胜制
    async getBestOf() {
      const res = await apiBestOf();
      if (res.code == 0) {
        this.pullDownData.smtBestOfList = res.data;
      }
    },
    colStyle({columnIndex}) {
    if (columnIndex ==0) {
      return 'cursor: move;'
    }
  }
  },

};
</script>

<style lang="less" scoped>
.processPage {
  width: 100%;
  height: 100%;
  display: flex;
  .myCheckBox {
    line-height: 33px;
    margin-bottom: 16px;
    padding-left: 40px;
  }
}
</style>
<style lang="less">
.workStationCascader {
  .el-scrollbar:nth-child(1) {
    .el-radio {
      visibility: hidden;
    }
  }
}
.drag_move {}
</style>
